
// import React, { useRef, useEffect, useMemo } from 'react';
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';

// const DocxTextBlock = ({ block, index, onUpdate }) => {
//     const editableDivRef = useRef(null);

//     // Stable MTQP score
//     const mtqpScore = useMemo(() => Math.floor(Math.random() * 10) + 90, []);

//     // Set initial content only once (on mount)
//     useEffect(() => {
//         if (!editableDivRef.current || !block) return;

//         const container = editableDivRef.current;
//         container.innerHTML = ''; // Clear initial content

//         block.forEach((segment, i) => {
//             const span = document.createElement('span');
//             span.textContent = segment.text;
//             span.dataset.id = segment.id || s${ i };
//             span.dataset.paraId = segment.paraId || '';
//             span.dataset.textId = segment.textId || '';
//             span.dataset.sentId = segment.sentId || 0;

//             span.style.margin = '0 2px';
//             span.style.display = 'inline';

//             if (segment.style) {
//                 span.className = segment.style;
//             }

//             container.appendChild(span);
//         });
//     }, []); // Empty dependency: only run once

//     // On paste: insert plain text only
//     const handlePaste = (e) => {
//         e.preventDefault();

//         const plainText = (e.clipboardData || window.clipboardData).getData('text/plain');
//         insertTextAtCursor(plainText);

//         // Let DOM update before blur
//         setTimeout(handleBlur, 0);
//     };

//     // Insert plain text at caret
//     const insertTextAtCursor = (text) => {
//         const selection = window.getSelection();
//         if (!selection.rangeCount) return;

//         const range = selection.getRangeAt(0);
//         range.deleteContents();

//         const textNode = document.createTextNode(text);
//         range.insertNode(textNode);

//         // Move cursor after inserted text
//         range.setStartAfter(textNode);
//         range.setEndAfter(textNode);
//         selection.removeAllRanges();
//         selection.addRange(range);
//     };

//     // On blur: extract current segments
//     const handleBlur = () => {
//         const container = editableDivRef.current;
//         if (!container) return;

//         const children = Array.from(container.childNodes);
//         const newSegments = [];

//         children.forEach((node, i) => {
//             if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SPAN') {
//                 newSegments.push({
//                     id: node.dataset.id || s${ i },
//                     paraId: node.dataset.paraId || '',
//                     textId: node.dataset.textId || '',
//                     sentId: parseInt(node.dataset.sentId) || 0,
//                     text: node.textContent,
//                     style: node.className || ''
//                 });
//     } else if (node.nodeType === Node.TEXT_NODE) {
//         newSegments.push({
//             id: s${ i },
//             paraId: '',
//             textId: '',
//             sentId: i,
//             text: node.textContent,
//             style: ''
//                 });
// }
//         });

// onUpdate?.(index, newSegments);
//     };

// return (
//     <div className='d-flex gap-1 align-content-center'>
//         {/* MTQP Score */}
//         <div>
//             <OverlayTrigger
//                 placement="top"
//                 overlay={
//                     <Tooltip id="tooltip">
//                         Machine Translation Quality Prediction (MTQP): A score indicating translation quality. High quality: above 0.75
//                     </Tooltip>
//                 }
//             >
//                 <span className="bg-primary text-small fs_12 px-2 py-1 text-white rounded">
//                     {mtqpScore}
//                 </span>
//             </OverlayTrigger>
//         </div>

//         {/* Editable Text Area */}
//         <div
//             ref={editableDivRef}
//             contentEditable
//             suppressContentEditableWarning
//             onPaste={handlePaste}
//             onBlur={handleBlur}
//             className="p-1"
//             style={{
//                 width: '100%',
//                 overflow: 'hidden',
//                 textAlign: 'start',
//                 fontSize: '14px',
//                 lineHeight: '1.5',
//                 borderRadius: '5px',
//                 backgroundColor: '#fff',
//                 outline: 'none',
//             }}
//         />
//     </div>
// );
// };

// export default DocxTextBlock;




import React, { useState, useEffect, useRef } from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const DocxTextBlock = ({ index, sentencePair, onUpdate, isSelected }) => {
    const [text, setText] = useState(sentencePair.currentTranslated || "");
    const textareaRef = useRef(null);

    useEffect(() => {
        setText(sentencePair.currentTranslated || "");
    }, [sentencePair.currentTranslated]);

    useEffect(() => {
        if (isSelected && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [isSelected]);

    useEffect(() => {
        autoResize();
    }, [text]);

    const handleTextChange = (e) => {
        const newText = e.target.value;
        setText(newText);
    };

    const handleBlur = () => {
        if (text !== sentencePair.currentTranslated) {
            onUpdate(index, text);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            textareaRef.current.blur();
        }
    };

    const autoResize = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto"; // Reset height
            textarea.style.height = `${textarea.scrollHeight}px`; // Set to scroll height
        }
    };

    function getRandomNumber() {
        return Math.floor(Math.random() * 10) + 90;
    }

    return (
        <div className='d-flex gap-2 align-items-start'>
            <div>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip">
                            Machine Translation Quality Prediction: Score indicating translation quality. High quality: above 0.75
                        </Tooltip>
                    }
                >
                    <span className="bg-primary text-small fs_12 px-2 py-1 text-white rounded">
                        {getRandomNumber()}
                    </span>
                </OverlayTrigger>
            </div>
            <textarea
                ref={textareaRef}
                value={text}
                onChange={handleTextChange}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                rows={1}
                className="p-2 auto-resize-textarea"
                placeholder="Edit translation..."
                style={{
                    width: '100%',
                    border: '1px solid #ffffffff',
                    borderRadius: '4px',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    resize: 'none',
                    outline: 'none',
                    fontFamily: 'inherit',
                    textAlign: "start",
                    overflow: 'hidden'
                }}
            />

        </div>
    );
};

export default DocxTextBlock;
